export default __webpack_public_path__ + "img/58e8bcf9038996901a196ee1f0ad1496.png";